const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNaviqIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 61.2182,
    height: 61.3551,
    viewBox: "0 0 61.2182 61.3551",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    d: "M30.6094 16.3319C38.4103 16.332 44.7344 22.656 44.7344 30.4569C44.7343 38.2578 38.4102 44.5819 30.6094 44.5819C22.8084 44.5819 16.4844 38.2579 16.4844 30.4569C16.4844 22.656 22.8084 16.3319 30.6094 16.3319ZM30.6094 21.6288C25.7338 21.6288 21.7812 25.5813 21.7812 30.4569C21.7813 35.3325 25.7338 39.2851 30.6094 39.2851C35.4849 39.285 39.4374 35.3325 39.4375 30.4569C39.4375 25.5814 35.4849 21.6288 30.6094 21.6288Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 6",
    d: "M0.593529 26.4842L11.9654 16.7369C23.1206 7.17531 39.65 7.41655 50.5214 17.2996L60.6244 26.4842",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 1.76561,
    strokeDasharray: "4.41 4.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 7",
    d: "M60.6247 34.8709L49.2528 44.6182C38.0976 54.1798 21.5682 53.9385 10.6969 44.0554L0.593839 34.8709",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 1.76561
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaviqIcon);
export default __webpack_public_path__ + "static/media/naviq-icon.39ae1d42290ce5fc4c0b534d796b6cc1.svg";
export { ForwardRef as ReactComponent };